import { ChangeEvent } from 'react'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface StoreCatalogSearchProps {
  value: string
  onChange: (val: string) => void
}

const StoreCatalogSearch: React.FC<StoreCatalogSearchProps> = ({ value, onChange }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const handleClear = () => {
    onChange('')
  }

  return (
    <div style={{ position: 'relative', padding: '' }}>
      <input
        type="text"
        className="my-search-input"
        placeholder="Buscar productos..."
        value={value}
        onChange={handleChange}
        style={{
          fontSize: '1rem',
          paddingLeft: '2rem',
          width: '300px',

          // Notice: border and border-radius are moved to CSS
        }}
      />
      <FontAwesomeIcon
        icon={faMagnifyingGlass}
        style={{
          position: 'absolute',
          left: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#888',
        }}
      />
      {value && (
        <button
          type="button"
          onClick={handleClear}
          style={{
            position: 'absolute',
            right: 6,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1.2rem',
            fontWeight: 'bold',
            lineHeight: 1,
          }}
        >
          ×
        </button>
      )}
    </div>
  )
}

export default StoreCatalogSearch
